/**
 * @file Parent pay camp with charity entry text.
 */

import React from 'react';
import PropTypes from 'prop-types';

import {
  getAccountCheckoutGreetingName,
  getAccountUsername,
} from '../../../util/account';
import { getAsset } from '../../../util/assets';
import Button from '../../global/Button';
import OnboardingLayoutContentNarrow from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutContentNarrow';

const propTypes = {
  albumFolder: PropTypes.shape({
    name: PropTypes.string,
    has_charity: PropTypes.bool,
    charity_description: PropTypes.string,
    charity_footnote: PropTypes.string,
    is_demo: PropTypes.bool,
    has_free_trial: PropTypes.bool,
    account: PropTypes.shape({
      name: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }).isRequired,
  onGetStarted: PropTypes.func,
};

const DiscoverAlbumFolderStartCampParentPayCharity = ({
  albumFolder,
  onGetStarted,
}) => {
  const displayName = getAccountCheckoutGreetingName(albumFolder.account);
  const username = getAccountUsername(albumFolder.account);
  const displayNameComponent = (() => {
    if (username) {
      return (
        <a href={`/@${username}`} className="text-sm mb-2">
          By {displayName}
        </a>
      );
    }
    return <p className="text-sm">By {displayName}</p>;
  })();

  return (
    <OnboardingLayoutContentNarrow>
      <h4 className="mb-1 text-center">Welcome to</h4>
      <h2 className="text-black mb-1 text-center">{albumFolder.name}!</h2>

      {displayName && displayNameComponent}

      <p className="text-center">Bye&ndash;bye bloodshot eyes! Hello, Waldo!</p>

      <p className="text-center">
        Waldo uses facial recognition to find your camper&rsquo;s photos and
        text them to you.
      </p>

      {albumFolder.charity_description ? (
        <p className="mb-0 text-center">{albumFolder.charity_description}</p>
      ) : (
        <p className="mb-0 text-center">
          And... 50% of every subscription goes to camper scholarships!
        </p>
      )}

      <p className="text-xs text-muted text-center mt-2 mb-0">
        {albumFolder.charity_footnote ? (
          albumFolder.charity_footnote
        ) : (
          <span>*Up to $22.50 per camper.</span>
        )}
      </p>
      <img
        src={getAsset('/waldo-way.png')}
        height="140px"
        className="my-2"
        alt="Waldo Way"
      />
      <Button onClick={onGetStarted} className="mt-2" btnBlock>
        Let&apos;s Get Started!
      </Button>

      <div className="d-flex mt-1">
        <a href="/terms" target="_blank" className="m-auto text-xs">
          Terms of Use
        </a>
      </div>
    </OnboardingLayoutContentNarrow>
  );
};

DiscoverAlbumFolderStartCampParentPayCharity.propTypes = propTypes;

export default DiscoverAlbumFolderStartCampParentPayCharity;
